const authorPortraitSize = '256';
const carouselImgMaxWidth = '600';

export const authorPortraitParams = `?fit=crop&f=face&w=${authorPortraitSize}&h=${authorPortraitSize}`;
export const carouselImageParams = `?fit=scale&w=${carouselImgMaxWidth}`;
